import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import PlaySvg from '../../svg/Play';
import Mission1 from './new4tasks/Mission1';
import Mission2 from './new4tasks/Mission2';
import Mission3 from './new4tasks/Mission3';
import Mission4 from './new4tasks/Mission4';

const TASKS = [
  {
    id: 1,
    photo: '/閱讀策略/1.png',
    name: '策略1：找有關的顯性訊息',
    subtitle: '閱讀策略 1'
  },
  {
    id: 2,
    photo: '/閱讀策略/2.png',
    name: '策略2：推論超連結是否有用',
    subtitle: '閱讀策略 2'
  },
  {
    id: 3,
    photo: '/閱讀策略/3.png',
    name: '策略3：歸納來自相同或不同網頁的訊息',
    subtitle: '閱讀策略 3'
  },
  {
    id: 4,
    photo: '/閱讀策略/4.png',
    name: '策略4：判定網站上訊息是否可靠',
    subtitle: '閱讀策略 4'
  }
]
function Component(props) {
  const { } = useParams();
  const navigate = useNavigate();
  const [data, setdata] = useState(null)
  const [isLoading, setisLoading] = useState(false)
  const [mission, setMission] = useState(null)



  const isMobile = window.innerWidth < 1024

  if (mission?.id === 1)
    return (
      <Mission1 onClose={() => setMission(null)} />
    )
  if (mission?.id === 2)
    return (
      <Mission2 onClose={() => setMission(null)} />
    )
  if (mission?.id === 3)
    return (
      <Mission3 onClose={() => setMission(null)} />
    )
  if (mission?.id === 4)
    return (
      <Mission4 onClose={() => setMission(null)} />
    )

  return (
    <div className='flex-[1] flex flex-col h-full' style={{ overflowY: "auto", gap: isMobile ? '8px' : '16px', padding: isMobile ? '8px' : '16px' }}>


      {/*button to redirect to practice page*/}
      <div className='w-full flex flex-row gap-[12px]'>
        <div className='flex flex-row gap-[8px] items-center justify-start items-center cursor-pointer' onClick={
          () => {
            navigate(-1)
          }
        }>
          <div className='text-[#214BFF] font-[700]' style={{ fontSize: '2rem' }}>返回</div>
        </div>

      </div>
      {/*end of button*/}

      {/*description section*/}
      <div className='flex flex-col w-full text-[1.5rem]' style={{ textAlign: 'justify' }}>
        在線上閱讀找自己感興趣的話題、學習或做研究探索等，困難還真不少呢！因為網上的內容常常是跳來跳去的，一按連結就會轉到其他頁面，而且畫面上還有許多圖片、影片或其他吸引人的資訊，很容易讓人分心；不像看書那樣，可以一頁一頁慢慢看。有些重要資料還藏在連結裏，不容易一下子找到。
        <br /><br />
        網上也可能有不正確或虛假的內容，我們需要小心分辨。不過大家不用擔心，只要按部就班，學會以下四個線上閱讀策略，你也能成為線上閱讀小達人！
      </div>



      <div className='flex flex-row gap-[16px] w-full flex-wrap' style={{}}>
        {TASKS?.map((item, index) =>
          <div key={item?._id || index} className='rounded-[20px] bg-[white] flex flex-col cursor-pointer hover:opacity-[.8]' style={{
            overflow: 'hidden', height: isMobile ? 300 / 3 * 2 : 300, width: isMobile ? 550 / 3 * 2 : 550,
          }}
            onClick={() => {
              setMission(item)
            }}>
            <img src={item?.photo} className='w-full rounded-[20px]' style={{ height: isMobile ? 205 / 3 * 2 : 205, objectFit: 'cover' }} />
            <div className='flex flex-row w-full'>
              <div className='flex flex-col flex-1'>
                <div className='flex flex-row w-full items-end text-[#43528A] flex-wrap' style={{ paddingLeft: isMobile ? 8 : 16, paddingRight: isMobile ? 8 : 16, gap: isMobile ? 4 : 16, paddingTop: isMobile ? 2 : 8 }}>
                  <div className='text-[#43528A] font-[700]' style={{ fontSize: isMobile ? 14 : 24 }}>{item?.name}</div>
                </div>
                <div className='mt-[2px] flex flex-row w-full items-end text-[#43528A] flex-wrap' style={{ paddingLeft: isMobile ? 8 : 16, paddingRight: isMobile ? 4 : 16, gap: isMobile ? 8 : 16 }}>
                  <div className='' style={{ fontSize: isMobile ? 12 : 18 }}>{item.subtitle}</div>
                </div>
              </div>
              <div className='h-full flex flex-row items-center' style={{ padding: isMobile ? 4 : 16 }}>
                <PlaySvg width={isMobile ? 28 : 44} />
              </div>
            </div>
          </div>
        )}
      </div>
      {/*end of missions*/}

      {isLoading && <LoadingPage />}
    </div>
  );
}
export default connect((store) => {
  return {
    token: store.tokenReducer,
  }
})(Component)
